import { getFirestore, collection, getDocs, query, where } from 'firebase/firestore';
import { getApps } from 'firebase/app';

function formatPrice(num, operation) {
  if (!num) return '$ 0 COP';
  const formatted = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  return `$ ${formatted} COP${operation === 'Arriendo' ? ' / mes' : ''}`;
}

export async function fetchAvailableProperties() {
  try {
    const apps = getApps();
    if (!apps.length) {
      console.warn('[propertiesService] Firebase no está inicializado aún.');
      return [];
    }
    const db = getFirestore(apps[0]);
    const propertiesRef = collection(db, 'properties');
    const q = query(propertiesRef, where('isAvailable', '==', true));
    const snapshot = await getDocs(q);

    const properties = snapshot.docs.map(doc => {
      const data = doc.data();
      const operation = data.operation || 'Venta';
      
      const mainImage = data.image || '';
      const rawGallery = data.gallery || [];
      const gallery = mainImage && !rawGallery.includes(mainImage) 
          ? [mainImage, ...rawGallery] 
          : rawGallery;

      return {
        id: doc.id,
        code: data.code || '',
        title: data.title || '',
        operation: operation,
        type: data.type || '',
        city: data.city || '',
        location: data.address || '',
        price: data.price || 0,
        priceFormatted: formatPrice(data.price || 0, operation),
        bedrooms: data.bedrooms || 0,
        bathrooms: data.bathrooms || 0,
        area: data.area || 0,
        builtArea: data.builtArea || 0,
        stratum: data.stratum || 3,
        featured: data.featured || false,
        image: mainImage,
        gallery: gallery,
        description: data.description || '',
        features: data.features || []
      };
    });

    return properties;
  } catch (error) {
    console.error('[propertiesService] Error fetching properties:', error);
    return [];
  }
}
